import { defaultTheme } from "react-admin";
import merge from "lodash/merge";

const theme = merge({}, defaultTheme, {
  sidebar: {
        width: 280,
  },
  palette: {
    mode: "light",
    primary: {
      main: "#2f2f2f",
    },
    secondary: {
      main: "#db1d3f",
    },
    success: {
      main: "#05ab47",
    },
    gray: {
      50: "#F7FAFC",
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: [
      "Inter",
      "TT Commons",
      "Flatface Haleys Sans",
      "Flatface Haleys Script",
    ].join(","),
    fontSize: 14,
    h1: { fontWeight: 600, fontSize: "1.9rem", lineHeight: 1.2 },
    h2: { fontWeight: 600, fontSize: "1.65rem", lineHeight: 1.25 },
    h3: { fontWeight: 500, fontSize: "1.4rem", lineHeight: 1.3 },
    h4: { fontWeight: 500, fontSize: "1.2rem", lineHeight: 1.35 },
    h5: { fontWeight: 500, fontSize: "1.05rem", lineHeight: 1.4 },
    h6: { fontWeight: 500, fontSize: "1rem", lineHeight: 1.4 },
    subtitle1: { fontWeight: 400, fontSize: "0.95rem", lineHeight: 1.45 },
    subtitle2: { fontWeight: 400, fontSize: "0.88rem", lineHeight: 1.45 },
    body1: { fontWeight: 400, fontSize: "0.95rem", lineHeight: 1.5 },
    body2: { fontWeight: 400, fontSize: "0.88rem", lineHeight: 1.45 },
    button: {
      textTransform: "none",
      fontWeight: 500,
      fontSize: "0.9rem",
    },
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        size: "small",
      },
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
      variants: [
        {
          props: { variant: "red-rounded" },
          style: {
            background: "#db1d3f",
            border: `1px solid white`,
            borderRadius: 64,
            textTransform: "none",
            color: "white",
            "&:hover": {
              background: "rgba(219, 29, 63, 0.7)",
            }
          }
        },
        {
          props: { variant: "white-rounded" },
          style: {
            background: "#F7FAFC",
            border: `1px solid white`,
            borderRadius: 64,
            textTransform: "none",
            color: "#2f2f2f",
            "&:hover": {
              background: "rgba(0, 0, 0, 0.1)",
            }
          }
        },
        {
          props: { variant: "white-rounded-filled" },
          style: {
            background: "white",
            border: `1px solid white`,
            borderRadius: 64,
            textTransform: "none",
            color: "#db1d3f",
            "&:hover": {
              opacity: 1,
              background: "white"
            }
          }
        },
        {
          props: { variant: "shadow-rounded-hover" },
          style: {
            background: "none",
            border: "none",
            borderRadius: 64,
            textTransform: "none",
            "&:hover": {
              background: "rgba(0, 0, 0, 0.1)",
            }
          }
        }
      ]
    },
    MuiChip: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          fontSize: "0.8rem",
          fontWeight: 500,
          backgroundColor: "#db1d3f",
          color: "white",
          margin: 0,
        },
        deleteIcon: {
          color: "white",
          "&:hover": {
            color: "white",
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        margin: "dense",
        // size: "small",
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: "white",
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        margin: "dense",
        size: "small",
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          paddingTop: 6,
          paddingBottom: 6,
          fontSize: "0.88rem",
        },
        head: {
          fontWeight: 500,
          fontSize: "0.9rem",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        dense: {
          minHeight: 42,
        },
      },
    },
  },
});

export default theme;
